export default theme => ({

    stepLabelCustom: {
        "& span":{
            fontSize: "15px",
        }
    },
    pickedOption: { 
       color: theme.palette.secondary.main
    },
    stepContentCustom: {
        paddingLeft:0
    }
})

